import { configureCheckout } from "tf-checkout-react"

import { ENV } from "../constants/env"
import i18n, { DEFAULT_LOCALE } from "../i18n/config"

let configured = false

export const configureCheckoutKit = () => {
  if (configured) return

  configureCheckout({
    baseUrl: ENV.BASE_URL,
    clientId: ENV.CLIENT_ID,
    clientSecret: ENV.CLIENT_SECRET,
    sourceOrigin: ENV.X_SOURCE_ORIGIN,
    cookieAuth: true,
    // The backend writes every email for an order — the confirmation, and the
    // guest ticket a delegation issues — in the language it recorded when the
    // order was created, which it reads from this header. Left to the browser,
    // that is the language of whoever placed the order, not of the site: a
    // guest-list manager on an English-language laptop sent English tickets
    // from a Spanish storefront. Read per request so it follows the switcher.
    //
    // Despite the option's name this adds a header and replaces none.
    // Accept-Language is CORS-safelisted, so it needs no backend allow-list.
    auth: () => ({ "Accept-Language": i18n.resolvedLanguage || DEFAULT_LOCALE })
  })
  configured = true
}
